import React from 'react';

const ReusableInputButton = ({ 
  placeholder = "Enter text...", 
  onClick, 
  className = '', 
  buttonLabel = 'Submit', 
  type = 'submit' 
}) => {
  return (
      <button 
        onClick={onClick} 
        type={type} 
        className={`px-4 py-2 h-full rounded ${className}` }
        style={{ fontFamily: "bold" }}
      >
        {buttonLabel}
      </button>
  );
};

export default ReusableInputButton;
